// extracted by mini-css-extract-plugin
module.exports = {"container":"SecondaryDashboardButton_container__2pk9w"};